import React, { useState, useEffect } from "react";
import axios from "axios";

const OTPViewer = () => {
    const [otpData, setOtpData] = useState([]);
    const [newUser, setNewUser] = useState("");
    const [newUserEmail, setNewUserEmail] = useState("");
    const [newUserPassword, setNewUserPassword] = useState("");

    useEffect(() => {
        // Fetch OTP data from backend
        axios
            .post("http://localhost:8000/api/auth/get_otp")
            .then((res) => setOtpData(res.data.otpList))
            .catch((err) => console.error(err));
    }, []);

    const handleCreateUser = () => {
        const payload = {
            username: newUser,
            email: newUserEmail,
            password: newUserPassword,
        };
        axios
            .post("http://localhost:8000/api/auth/insert_new_user", payload)
            .then((res) => {
                setNewUser("");
                setNewUserEmail("");
                setNewUserPassword("");
                // Optionally refresh the OTP list after adding new user
                axios
                    .post("http://localhost:8000/api/auth/get_otp")
                    .then((res) => setOtpData(res.data.otpList))
                    .catch((err) => console.error(err));
            })
            .catch((err) => console.error(err));
    };

    return (
        <div className="p-4 bg-white shadow rounded">
            <h3 className="text-xl font-semibold mb-3">OTP Codes</h3>
            {otpData.length === 0 ? (
                <p className="text-gray-500">No OTP codes found.</p>
            ) : (
                <table className="min-w-full border border-gray-300 mb-4">
                    <thead className="bg-gray-200">
                        <tr>
                            <th className="py-2 px-4 border">ID</th>
                            <th className="py-2 px-4 border">OTP Code</th>
                            <th className="py-2 px-4 border">User</th>
                        </tr>
                    </thead>
                    <tbody>
                        {otpData.map((item) => (
                            <tr key={item.id} className="hover:bg-gray-100">
                                <td className="py-2 px-4 border">{item.id}</td>
                                <td className="py-2 px-4 border">{item.otp}</td>
                                <td className="py-2 px-4 border">{item.user}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            <div>
                <h4 className="text-lg font-medium mb-2">Create User Without OTP</h4>
                <input
                    type="text"
                    placeholder="Username"
                    className="border px-3 py-2 rounded mr-2"
                    value={newUser}
                    onChange={(e) => setNewUser(e.target.value)}
                />
                <input
                    type="email"
                    placeholder="Email"
                    className="border px-3 py-2 rounded mr-2"
                    value={newUserEmail}
                    onChange={(e) => setNewUserEmail(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    className="border px-3 py-2 rounded mr-2"
                    value={newUserPassword}
                    onChange={(e) => setNewUserPassword(e.target.value)}
                />
                <button
                    className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                    onClick={handleCreateUser}
                >
                    Create
                </button>
            </div>
        </div>
    );
};

export default OTPViewer;